<template>
  <section>
    <main role="main" class="container section">
      <div class="content has-text-centered">
        <h1 class="title">FAQs</h1>
      </div>
      <div>
        <b-collapse
          v-for="(faq, index) in faqs"
          :key="index"
          :open="false"
          class="card"
        >
          <div slot="trigger" slot-scope="props" class="card-header">
            <p class="card-header-title">
              {{ faq.question }}
            </p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'" />
            </a>
          </div>
          <div class="card-content">
            <div class="content">{{ faq.answer }}</div>
          </div>
        </b-collapse>
      </div>
    </main>
  </section>
</template>

<script>
import faqs from '@/data/faqs'
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'Frequently Asked Questions',
  pageDescription:
    "Here's a list of questions we are asked frequently. If you don't see your question below, feel free to email us",
  pageURL: 'http://www.chinchillaessentials.com/faqs',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'FAQ',
  metaInfo: () => getPageMeta(meta),
  data() {
    return {
      faqs
    }
  }
}
</script>
